import React from 'react'
import MdcAppLoader from '@/components/MdcAppLoader'

/**
 * Reusable Button component
 *
 * @param {Object} props Component props
 * @param {string} [props.variant='primary'] Button variant ('primary' or 'secondary')
 * @param {boolean} [props.disabled=false] Whether the button is disabled
 * @param {React.ReactNode} props.children Button content
 * @param {Function} [props.onClick] Click handler
 * @param {string} [props.type='button'] Button type
 * @param {string} [props.className] Additional class name
 * @returns {JSX.Element} Button component
 */
const Button = ({
  variant = 'primary',
  size = 'md',
  disabled = false,
  children,
  onClick,
  type = 'button',
  className = '',
  loading = false,
  ...rest
}) => {
  return (
    <button
      type={type}
      className={`mdc-button mdc-button--${variant} mdc-button--size-${size} ${className}`}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      <span className="mdc-button__label">
        {loading ? <MdcAppLoader padding={0} size={16} display="inline" /> : children}
      </span>
    </button>
  )
}

export default Button
